import HttpService from '../baseHttp'


// 采购申请列表，查看，编辑
export const HttpGetApplicateList = (data = {}, config) => HttpService.get('/api/v2/poRequisition/findByPage', { params: data })

export const HttpGetApplicateOne = (data = {}, config) => HttpService.get('/api/v2/poRequisition/findById', { params: data })

export const HttpSaveApplicateOne = (data = {}, config) => HttpService.post('/api/v2/poRequisition/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 批量提交，添加备注
export const HttpGetApplicateSubmit = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchSubmit', { params: data })

export const HttpGetApplicateNotes = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchAddRemark', { params: data })

// 关闭，取消，审核，删除
export const HttpGetApplicateClose = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchClose', { params: data })

export const HttpGetApplicateCancel = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchCancel', { params: data })

export const HttpGetApplicateCheck = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchCheck', { params: data })

export const HttpGetApplicateDelete = (data = {}, config) => HttpService.get('/api/v2/poRequisition/batchDelete', { params: data })

export const HttpGetDingLog = (data = {}, config) => HttpService.get('/api/v2/StockOpLog/ding/findAll', { params: data })

// 申请单去除异常
// export const HttpReqRemoveError = (data = {}, config) => HttpService.post('/api/v2/poRequisition/removeError', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpReqRemoveError = (data = {}, config) => HttpService.get('/api/v2/poRequisition/removeError', { params: data })
// 

// PO创建采购单
export const HttpSavePoPurchase = (data = {}, config) => HttpService.post('/api/v2/poRequisition/transferIntoPoOrder', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

// 转采购明细
export const HttpGetTransPoDetail = (data = {}, config) => HttpService.get('/api/v2/poRequisition/poRequisitionTransPoDetail', { params: data })
// 删除单条附件
export const HttpDeleteApplicateFile = (data = {}, config) => HttpService.get('/api/v2/poRequisition/deleteFile', { params: data })


// 采购单列表，查看，编辑
export const HttpGetOrderList = (data = {}, config) => HttpService.get('/api/v2/po/findByPage', { params: data })

export const HttpGetOrderOne = (data = {}, config) => HttpService.get('/api/v2/po/findById', { params: data })

export const HttpSaveOrderOne = (data = {}, config) => HttpService.post('/api/v2/po/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 删除单条附件
export const HttpDeleteOrderFile = (data = {}, config) => HttpService.get('/api/v2/po/deleteFile', { params: data })

// 确认，取消，删除，添加备注, 关闭，审核通过/驳回
export const HttpGetOrderSubmit = (data = {}, config) => HttpService.get('/api/v2/po/batchSubmit', { params: data })

export const HttpGetOrderCancel = (data = {}, config) => HttpService.get('/api/v2/po/batchCancel', { params: data })

export const HttpGetOrderDelete = (data = {}, config) => HttpService.get('/api/v2/po/batchDelete', { params: data })

export const HttpGetOrderNotes = (data = {}, config) => HttpService.get('/api/v2/po/batchAddRemark', { params: data })

export const HttpGetOrderClose = (data = {}, config) => HttpService.get('/api/v2/po/batchClose', { params: data })

export const HttpGetAuditing = (data = {}, config) => HttpService.get('/api/v2/po/batchAuditing', { params: data })
// 根据采购申请详情内容
export const HttpGetApplicateIds = (data = {}, config) => HttpService.get('/api/v2/poRequisition/findAllByIds', { params: data })

// 根据申请单号查询
export const HttpGetApplicateNos = (data = {}, config) => HttpService.get('/api/v2/poRequisition/findAllByOrderNos', { params: data })


// 创建的采购明细/采购申请导入弹框下载和上传
export const HttpGetBoxDetailDownload = (data = {}, config) => HttpService.get('/api/v2/po/downItemExcel', { params: data })
export const HttpBoxDetailSave = (data = {}, config) => HttpService.post('/api/v2/po/importItemExcel', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })


// 供应商列表，查看，编辑，停用
export const HttpGetSupplier = (data = {}, config) => HttpService.get('/api/v2/Supplier/findByPage', { params: data })

export const HttpGetSupplierOne = (data = {}, config) => HttpService.get('/api/v2/Supplier/findById', { params: data })

export const HttpSaveSupplierOne = (data = {}, config) => HttpService.post('/api/v2/Supplier/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

export const HttpStopSupplier = (data = {}, config) => HttpService.get('/api/v2/Supplier/batchStop', { params: data })


// 所有供应商，不分页

export const HttpGetAllSupplier = (data = {}, config) => HttpService.get('/api/v2/Supplier/findAllByContextId', { params: data })


// 根据仓库获取仓库对应渠道
export const HttpFindByOrgIdAndOrgWarehouseId = (data = {}) => HttpService.get('/api/v2/accountChannel/findByOrgIdAndOrgWarehouseId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


// 供应商产品列表
export const HttpGetSupplierProduct = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/findByPage', { params: data })
// 供应商产品单条查看
export const HttpGetSupplierProductOne = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/findById', { params: data })
// 供应商产品单条保存
export const HttpSaveSupplierProductOne = (data = {}, config) => HttpService.post('/api/v2/SupplierProduct/save', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })
// 供应商产品失效
export const HttpSupplierProductUnactive = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/batchUnactive', { params: data })
// 供应商产品激活
export const HttpSupplierProductActive = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/batchActive', { params: data })
// 获取产品单价
export const HttpGetProductPrice = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/findPrice', { params: data })


// 交货信息的接口
// 查询交货
export const HttpGetDeliverOne = (data = {}, config) => HttpService.get('/api/v2/po/findAllDeliver', { params: data })
// 提交交货
export const HttpSaveDeliver = (data = {}, config) => HttpService.post('/api/v2/po/saveDeliver', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })
// 批量验货
export const HttpBatchInspection = (data = {}) => HttpService.get("/api/v2/po/batchInspection",{ params: data });


// 采购价格带出
export const HttpGetPrice = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/findAllPrice', { params: data })

// 删除附件-编辑
export const HttpDelAttach = (data = {}, config) => HttpService.get('/api/v2/po/delRelAttach', { params: data })
export const HttpPODelAttach = (data = {}, config) => HttpService.get('/api/v2/poRequisition/delRelAttach', { params: data })

// 删除附件-新增
export const HttpDelAttachNew = (data = {}) => HttpService.get('/api/v1/BizAttach/del', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })


// 重置申请单、采购单
export const HttpResetApplication = (data = {}, config) => HttpService.get('/api/v2/poRequisition/reset', { params: data })
export const HttpResetOrder = (data = {}, config) => HttpService.get('/api/v2/po/reset', { params: data })

// 获取资金方列表
export const HttpFindProvidersByOrg = (data = {}, config) => HttpService.get('/api/mg/fk-funder/findValidFunders', { params: data, baseURL: process.env.VUE_APP_APIURL_FK})
// 删除采购合同附件
export const HttpDelAttachPurchase = (data = {}, config) => HttpService.get('/api/v2/po/delPurchaseRelAttach', { params: data })
// 删除外销合同附件
export const HttpDelAttachExport = (data = {}, config) => HttpService.get('/api/v2/po/delExportRelAttach', { params: data })
// 供应商待审核
export const HttpAduitSupplier = (data = {}, config) => HttpService.post("/api/v2/Supplier/status", data, { baseURL: process.env.VUE_APP_APIURL_BOSS });


// 采购方列表
export const HttpGetPurchaserList = (data = {}, config) => HttpService.get('/api/v2/po/findAllPurchaserByContextId', { params: data })
// 预计修改发货时间
export const HttpGetExpectedInspectDate = (data = {}, config) => HttpService.get('/api/v2/po/modifyExpectedInspectDate', { params: data })

// 修改预计完成时间
export const HttpGetExpectedFinishDate = (data = {}, config) => HttpService.get('/api/v2/po/modifyExpectedFinishDate', { params: data })


// 保存验货
export const HttpConfirmInspect = (data) => HttpService.post('/api/v2/po/inspect', data, { baseURL: process.env.VUE_APP_APIURL_BOSS });

// 验货记录
export const HttpGetInspectByPoId = (data = {}, config) => HttpService.get('/api/v2/po/findInspectByPoId', { params: data })

// 修改合同日期
export const HttpGetContractSignDate = (data = {}, config) => HttpService.get('/api/v2/po/modifyContractSignDate', { params: data })

// 获取采购头部的数量
export const HttpGetCountPoOrder = (data = {}, config) => HttpService.get('/api/v2/po/countPoOrder', { params: data })

// 交货分页接口
export const HttpGetDeliverList = (data = {}, config) => HttpService.get('/api/v2/po/findAllDeliver', { params: data })

// 补充代采信息
export const HttpReplenishFKInfo = (data = {}, config) => HttpService.post('/api/v2/po/savePoFk', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })

// 采购申请单数字
export const HttpGetCountpoRequisition = (data = {}, config) => HttpService.get('/api/v2/poRequisition/countOrder', { params: data })

// 减少采购数量
export const HttpReduceQuantity = (data = {}, config) => HttpService.post('/api/v2/po/cancelQuantity', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })

// 一键减少采购数量
export const HttpAutoReduceQuantity = (data = {}, config) => HttpService.post('/api/v2/po/cancelItemQuantity', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })


export const HttpGetContract = (data = {}, config) => HttpService.get('/api/v2/po/exportTemplate', { params: data })

// 去除异常
export const HttpRemoveError = (data = {}, config) => HttpService.get('/api/v2/po/removeError', { params: data })


// 单个删除图片
export const HttpRemovePic = (data = {}, config) => HttpService.get('/api/v2/SupplierProduct/removePic', { params: data })

// 一键减少采购申请数量
export const HttpAutoReduceApplicaQuantity = (data = {}, config) => HttpService.post('/api/v2/poRequisition/cancelItemQuantity', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })

export const HttpReduceApplicaQuantity = (data = {}, config) => HttpService.post('/api/v2/poRequisition/cancelQuantity', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })

export const HttpExportPrice = (data = {}, config) => HttpService.get('/api/v2/po/exportExportPrice', { params: data });

export const HttpGetBuyerList = (data = {}, config) => HttpService.get('/api/v2/po/findBuyerList?type=0', { params: data });

export const HttpGetBuyerLabelById = (data = {}, config) => HttpService.get('/api/v2/po/getBuyer', { params: data });
// 港口分页查询
export const HttpGetSystemPortList = (data) => HttpService.get('/api/v2/systemPort/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 库存计划参数列表
export const HttpGetPlanParamList = (data) => HttpService.get('/api/v2/inventoryPlan/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 库存计划参数详情
export const HttpGetPlanParamDetail = (data) => HttpService.get('/api/v2/inventoryPlan/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 获取操作历史
export const HttpSysOpLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data })
// 需求预测
export const HttpGetForcastList = (data = {}, config) => HttpService.get('/api/v1/DemandForecast/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 需求预测详情
export const HttpGetForcast = (data = {}, config) => HttpService.get('/api/v1/DemandForecast/getById', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 需求预测编辑
export const HttpUpdateForcast = (data = {}, config) => HttpService.post('/api/v1/DemandForecast/update', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BI });
// 需求预测操作历史
export const HttpBISysOpLog = (data = {}, config) => HttpService.get('/api/v1/SysOpLog/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })
// 获取demandclass
export const HttpGetDemandForecast = (data = {}, config) => HttpService.get('/api/v1/DemandForecast/findAllClass', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 需求预测批量删除
export const HttpDeleteForecast = (data = {}, config) => HttpService.get('/api/v1/DemandForecast/batchDelete', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 更新预计交货时间
export const HttpUpdateExpectDeliveryDate = (data = {}) => HttpService.get('/api/v2/po/modifyExpectedDeliveryDate', { params: data })
// 获取理论最晚交期
export const HttpGetLastDeliveryDate = (data = {}) => HttpService.post('/api/v2/po/getLastDeliveryDate', data);
// 获取预计上架日期
export const HttpGetExpectedDate = (data = {}) => HttpService.post('/api/v2/po/getExpectedFinishedDateFromRe', data);
// 申请单重新计算
export const HttpBatchGetExpectedDate = (data = {}) => HttpService.get('/api/v2/poRequisition/batchGetExpectedDeliverDate', { params: data });
// 采购单重新计算日期
export const HttpBatchLastDate = (data = {}) => HttpService.get('/api/v2/po/batchGetLastDeliveryDate', { params: data });

// 提交附件的接口
export const HttpUpdateDoc = (data = {}, config) => HttpService.post('/api/v2/po/updateMeta', data, { headers: { "Content-Type": "application/json" }, params: {contextId: global.SYSID} })
// paymentterm列表
export const HttpPaymentTermList = (data = {}) => HttpService.get('/api/v1/arap/paymentTerm/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// paymentterm详情
export const HttpGetPaymentDetail = (data = {}) => HttpService.get('/api/v1/arap/paymentTerm/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });
// 获取日志数据
export const HttpGetLogData = (data = {}) => HttpService.get('/api/v1/arap/ar/findArApLogs', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })
// 获取payment
export const HttpGetPaymentByOrgId = (data = {}) => HttpService.get('/api/v1/arap/paymentTerm/findByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_BI })
// 采购单撤回提交
export const HttpBackSubmit = (data = {}) => HttpService.get('/api/v2/po/batchWithdraw', { params: data })
// 获取采购单钉钉状态
export const HttpGetDingStatus = (data = {}) => HttpService.get('/api/v2/po/getDingStatus', { params: data })

// 请求采购员下拉
export const HttpGetPersonList = (data = {}) => HttpService.get('/api/v2/inventoryPlan/findByType', { params: data });

// 亚马逊po库存导入
export const HttpGetPoAmazonList = (data = {}) => HttpService.get('/api/v2/forecastInventoryPlan/findByPage', { params: {...data,'search[EQ_status]':1} });
export const HttpGetPoAmazonDetail = (data = {}) => HttpService.get('/api/v2/forecastInventoryPlan/findById', { params: data });
// 重新关联sku
export const HttpReContentSku = (data = {}) => HttpService.get('/api/v2/forecastInventoryPlan/save', { params: data });
export const HttpCancelPoAmazon = (data = {}) => HttpService.get('/api/v2/forecastInventoryPlan/cancel', { params: data });

// 采购主体
export const HttpGetPurchaseMainList = (data = {}) => HttpService.get('/api/v2/poBuyer/findByPage', { params: data });
// 详情
export const HttpGetPurchaseMainDetail = (data = {}) => HttpService.get('/api/v2/poBuyer/findById', { params: data });
// 添加、编辑
export const HttpUpdatePurchaseMain = (data = {}) => HttpService.post('/api/v2/poBuyer/save', data, { headers: { 'Content-Type': 'application/json' } });
// 变更状态
export const HttpPurchaseMainChangeStatus = (data = {}) => HttpService.get('/api/v2/poBuyer/batchChangeStatus', { params: data });

export const HttpFilterDisabledWarehouse = (data = {}) => HttpService.get('/api/v2/organizationWarehouse/findOrgWarehousesByOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
